import { render, staticRenderFns } from "./AnchorList.vue?vue&type=template&id=6b598b5c&scoped=true"
import script from "./AnchorList.vue?vue&type=script&lang=js"
export * from "./AnchorList.vue?vue&type=script&lang=js"
import style0 from "./AnchorList.vue?vue&type=style&index=0&id=6b598b5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b598b5c",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/AnchorList.vue
// module id = 134
// module chunks = 0